import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import CoreStyles from '../core/Styles';
import Glyph from '../core/Glyph';
import {LabelSmallText} from '../core/Type';

export default class Radio extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            choice: {
                display: "flex",
                alignItems: "center",
                position: "relative",
            },
            input: {
                "-webkit-appearance": "none",
                position: "absolute",
                width: "100%",
                height: "100%",
                ":focus": {
                    outline: "none",
                },
            },
            radio: {
                width: CoreMetrics.IconSize.Medium(),
                height: CoreMetrics.IconSize.Medium(),
                borderRadius: "50%",
                backgroundColor: CoreMetrics.Color.LightUI.PrimaryBG,
                display: "flex",
                alignItems: "center",
                justifyItems: "center",
                padding: 0,
                margin: 0,
            },
            selected: {
                backgroundColor: CoreMetrics.Color.Control.Default,
            },
            label: {
                marginLeft: CoreMetrics.ElementPadding.XSmall(),
            },
        });

        const {selected, label} = this.props;
        let radioClasses = [styles.radio, CoreStyles.hairlineInnerStroke];
        if (selected) {
            radioClasses.push(styles.selected);
        }
        let radioIconElement = null;
        if (selected) {
            radioIconElement = <Glyph asset="assets/24x24-radio.svg" size={Glyph.Size.Medium} fillColor={CoreMetrics.Color.Neutral.White} />;
        }
        return (
            <div className={css(styles.choice)}>
                <input className={css(styles.input)} type="radio" onChange={this.handleChange} checked={selected} />
                <div className={css(radioClasses)}>{radioIconElement}</div>
                <LabelSmallText styles={[styles.label]}>{label}</LabelSmallText>
            </div>
        );
    }
    handleChange = (event) => {
        const selected = this.props.selected;
        const changeHandler = this.props.changeHandler;
        if (changeHandler != null) {
            changeHandler(!selected);
        }
    }
}



// WEBPACK FOOTER //
// ./src/controls/Radio.jsx